import React, { Component } from 'react';
import InputText from '../blueprintWrappers/InputText';
import SubmitButton from '../blueprintWrappers/SubmitButton';
import SelectWrapper from '../blueprintWrappers/SelectWrapper';
import { LoadingOverlay, Loader } from 'react-overlay-loader';
import CustomLoader from '../shared/CustomLoader';
import CancelButton from '../blueprintWrappers/CancelButton';

const titles = {
	'userName': 'User Name:',
	'lastName': 'Last Name:',
	'firstName': 'First Name:',
	'active': 'Active:',
	'dispatchUserType': 'Dispatch User Type:'
}

class UserEditable extends Component {
	render() {
		const { loading } = this.props;
		return <LoadingOverlay>
			<CustomLoader 
				loading = { loading }
				text = { 'Saving...' }
			/>
			{this.elementRender()}
		</LoadingOverlay>
	}

	elementRender = () => {
		const { cancelEditable, saveUser } = this.props;
		return <div className = 'user_editable pt-card'>
			{this.inputs('userName')}
			{this.inputs('firstName')}
			{this.inputs('lastName')}
			{this.selects('active')}
			{this.selects('dispatchUserType')}
			{this.resetPasswordSection()}
						<div className="user_editable_buttons">
							<SubmitButton 
									onClick = { saveUser }
							/>		 
							<CancelButton 
									onClick = { cancelEditable }
							/>
						</div>
		</div>;
	}

	inputs = (attr) => {
		return <div className = 'user_editable_row'>
			 <span className = 'editable_row_title'>
				{titles[attr]}
			</span>
			<InputText 
				{...this.propsInit(attr)}
			/>
		</div>
	}

	selects = (attr) => {
		return <div className = 'user_editable_row'>
			<span className = 'editable_row_title'>
				{titles[attr]}
			</span>
			<SelectWrapper
				{...this.propsInit(attr)}
			>
				{this.options(attr)}
			</SelectWrapper>
		</div>
	}

	resetPasswordSection = () => {
		const { resetPassword, keyName } = this.props;
		if(keyName === null) {
			return null;
		}
		return <div className = 'user_editable_row'>
			<span className = 'editable_row_title'>
				Password: 
			</span>
			<button
				className = 'pt-button'
				onClick = { resetPassword }
			>
				Reset Password
			</button>
			{this.copyToClipboardInput()}
		</div>;
	}

	copyToClipboardInput = () => {
		const { password } = this.props;
		if(password === null) {
			return null;
		}
		return <div className = 'copy_to_clipboard_input'>
					<div className="editable_row_title">
						<input
								value = { password }
								id = 'password'
								readOnly = { true }
								className = 'pt-input'
						/>
					</div>
			<button
				className = 'pt-button'
				onClick = { copyTo }
			>
				Copy to clipboard
			</button>
		</div>;


		function copyTo() {	
			let copyTextarea = document.getElementById('password');
			copyTextarea.select();
			try {
				let successful = document.execCommand('copy');
				let msg = successful ? 'successful' : 'unsuccessful';
				console.log('Copying text command was ' + msg);
			} catch (err) {
				console.log('Oops, unable to copy', err);
			}
		}
	}

	propsInit = (attr) => {
		const props = this.props;
		return {
			value: props[attr],
			onChange: this.onChange,
			returnObj: {
				attr
			}
		}
	}

	onChange = (val, returnObj) => {
		const { onChange } = this.props;
		onChange(val, returnObj.attr);
	}

	options = (attr) => {
		let optionsType = [];
		switch(attr) {
			case 'active':
				optionsType = ['Y', 'N'];
				break;
			case 'dispatchUserType':
				optionsType = ['Admin', 'Dispatch'];
				break;
		}
		return optionsType.map((opt, i) => {
			return <option key = {i}>{opt}</option>
		})
	}
}

export default UserEditable;


// WEBPACK FOOTER //
// ./src/components/users/UserEditable.jsx